import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../services/service.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
	selector: 'app-quisioner',
	templateUrl: './quisioner.component.html',
	styleUrls: ['./quisioner.component.css']
})
export class QuisionerComponent implements OnInit {

	warna: any = { A: "lightblue", B: "green", C: "yellow", D: "red", E: "indigo" };
	setting: any;
	jawaban: string = 'A';

	constructor(private router: Router, private service: ServiceService) {
		this.setting = this.service.getSetting();
		let extra = this.service.getExtra();
		if (extra.skor == null) {
			this.router.navigate(['/soal']);
		}
		if (this.setting.quisioner_pertanyaan == '') {
			this.router.navigate(['/skor']);
		}
	}

	ngOnInit() {
	}

	simpanQuisioner(btnSimpan) {
		$(btnSimpan).prop('disabled', true);
		$(btnSimpan).find('i').addClass('fa-circle-o-notch fa-spin');
		this.service.serviceSimpanQuisioner(this.jawaban).subscribe(data => {
			console.log('Quisioner Disimpan..');
			this.router.navigate(['/skor']);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/quisioner/quisioner.component.ts